import { useTranslation } from "react-i18next";
import type { Currency, Locale, Product } from "@nh/shared";
import { useShopProducts } from "../useShopProducts";
import { ProductBlockHeading } from "./ProductBlockHeading";
import { ProductCard } from "./ProductCard";

/**
 * "TE PUEDE INTERESAR": hasta tres productos de la misma categoría (o,
 * si la categoría va sola, los siguientes del catálogo). Es el bloque
 * "10 / Relacionados" de producción, que la ficha nueva no tenía: una
 * ficha que termina sin salida deja a la persona en un callejón.
 */
export function ProductRelated({
  product,
  currency,
  locale,
}: {
  product: Product;
  currency: Currency;
  locale: Locale;
}) {
  const { t } = useTranslation();
  const catalog = useShopProducts();
  const all = (catalog.data?.items ?? []).filter((item) => item.id !== product.id && item.type !== "membership");
  const sameCategory = all.filter((item) => item.category && item.category === product.category);
  const related = [...sameCategory, ...all.filter((item) => !sameCategory.includes(item))].slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="grid gap-7">
      <ProductBlockHeading eyebrow={t("Te puede interesar")} title={t("Relacionados")} />
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" aria-label={t("Relacionados")}>
        {related.map((item) => (
          <li key={item.id}>
            <ProductCard product={item} currency={currency} locale={locale} to={`/producto/${item.slug}`} />
          </li>
        ))}
      </ul>
    </section>
  );
}
